import React from 'react';
import { NavLink } from "react-router-dom";


const Header = () => {
    return (
        <>

  <header id="header" className="fixed-top ">
    <div className="container d-flex align-items-center">

      <h1 className="logo"><NavLink to="/">🔴 Covid-19 Live Tracker</NavLink></h1>
      
      <nav className="nav-menu d-none d-lg-block ml-auto">

        <ul >
          <li><NavLink exact to="/">Home</NavLink></li> 
          <li><NavLink exact to="/covidworld">Covid World Report</NavLink></li>
          {/* <li><NavLink exact to="/covidlive">Covid India Report</NavLink></li>
          <li><NavLink exact to="/statewise">Covid StateWise Report</NavLink></li> */}
          <li><NavLink exact to="/contact">Contact Us</NavLink></li>
         
        </ul>

      </nav>


    </div>
  </header>
        </>
    )
}

export default Header;
